module.exports = __webpack_public_path__ + "static/img/bio-lgchem-thumb.0b9edff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/bio-lgchem-thumb.jpg
// module id = ibTn
// module chunks = 0